// src/OfferContext.js
import React, { createContext, useState } from 'react';

export const OfferContext = createContext();

export const OfferProvider = ({ children }) => {
  const [offerResponse, setOfferResponse] = useState(null);

  return (
    <OfferContext.Provider value={{ offerResponse, setOfferResponse }}>
      {children}
    </OfferContext.Provider>
  );
};
